/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetItemMealTiersAdminResponse } from '../models/GetItemMealTiersAdminResponse';
import type { ItemAdminDto } from '../models/ItemAdminDto';
import type { ItemApprovalStatus } from '../models/ItemApprovalStatus';
import type { ItemClientDto } from '../models/ItemClientDto';
import type { ItemOperatorDto } from '../models/ItemOperatorDto';
import type { ItemOrderSupportType } from '../models/ItemOrderSupportType';
import type { Language } from '../models/Language';
import type { Pagination1OfItemAdminListedDto } from '../models/Pagination1OfItemAdminListedDto';
import type { Pagination1OfItemClientListedDto } from '../models/Pagination1OfItemClientListedDto';
import type { Pagination1OfItemDiscountAdminDto } from '../models/Pagination1OfItemDiscountAdminDto';
import type { Pagination1OfItemOperatorListedDto } from '../models/Pagination1OfItemOperatorListedDto';
import type { Pagination1OfMealCategoryItemListedClientDto } from '../models/Pagination1OfMealCategoryItemListedClientDto';
import type { Pagination1OfMealItemClientListedDto } from '../models/Pagination1OfMealItemClientListedDto';
import type { PostItemAdminRequest } from '../models/PostItemAdminRequest';
import type { PostItemOperatorRequest } from '../models/PostItemOperatorRequest';
import type { PutItemAdminRequest } from '../models/PutItemAdminRequest';
import type { PutItemAvailabilityOperatorRequest } from '../models/PutItemAvailabilityOperatorRequest';
import type { PutItemMealTiersAdminRequest } from '../models/PutItemMealTiersAdminRequest';
import type { PutItemOperatorRequest } from '../models/PutItemOperatorRequest';
import type { PutItemOrderRequestAdmin } from '../models/PutItemOrderRequestAdmin';
import type { PutItemPriceOperatorRequest } from '../models/PutItemPriceOperatorRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ItemsService {
    /**
     * @returns Pagination1OfItemOperatorListedDto OK
     * @throws ApiError
     */
    public static getItemsOperator({
        branchId,
        id,
        categoryId,
        mainCategoryId,
        subcategoryId,
        name,
        createdAtFrom,
        createdAtTo,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        branchId: number,
        id?: number,
        categoryId?: number,
        mainCategoryId?: number,
        subcategoryId?: number,
        name?: string,
        createdAtFrom?: string,
        createdAtTo?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfItemOperatorListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/items/{branchId}',
            path: {
                'branchId': branchId,
            },
            query: {
                'id': id,
                'categoryId': categoryId,
                'mainCategoryId': mainCategoryId,
                'subcategoryId': subcategoryId,
                'name': name,
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ItemOperatorDto OK
     * @throws ApiError
     */
    public static createItemOperator({
        branchId,
        requestBody,
    }: {
        branchId: number,
        requestBody?: PostItemOperatorRequest,
    }): CancelablePromise<ItemOperatorDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/operator/v1/items/{branchId}',
            path: {
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ItemOperatorDto OK
     * @throws ApiError
     */
    public static getItemOperator({
        id,
        branchId,
    }: {
        id: number,
        branchId: number,
    }): CancelablePromise<ItemOperatorDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/operator/v1/items/{id}/branch/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ItemOperatorDto OK
     * @throws ApiError
     */
    public static updateItemOperator({
        id,
        branchId,
        requestBody,
    }: {
        id: number,
        branchId: number,
        requestBody?: PutItemOperatorRequest,
    }): CancelablePromise<ItemOperatorDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/items/{id}/branch/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateItemAvailabilityOperator({
        id,
        branchId,
        requestBody,
    }: {
        id: number,
        branchId: number,
        requestBody?: PutItemAvailabilityOperatorRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/items/{id}/availability/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static updateItemPriceOperator({
        id,
        branchId,
        requestBody,
    }: {
        id: number,
        branchId: number,
        requestBody?: PutItemPriceOperatorRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/operator/v1/items/{id}/price/{branchId}',
            path: {
                'id': id,
                'branchId': branchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ItemClientDto OK
     * @throws ApiError
     */
    public static getItemClient({
        id,
    }: {
        id: number,
    }): CancelablePromise<ItemClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/items/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfMealCategoryItemListedClientDto OK
     * @throws ApiError
     */
    public static getMealCategoryItemsClient({
        id,
        companyId,
        name,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id: number,
        companyId?: number,
        name?: string,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealCategoryItemListedClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/items/mealcategory/{id}',
            path: {
                'id': id,
            },
            query: {
                'companyId': companyId,
                'name': name,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfItemClientListedDto OK
     * @throws ApiError
     */
    public static getItemsClient({
        branchId,
        showcaseId,
        name,
        venderId,
        categoryIds,
        minPrice,
        maxPrice,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        branchId?: number,
        showcaseId?: number,
        name?: string,
        venderId?: number,
        categoryIds?: Array<number>,
        minPrice?: number,
        maxPrice?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfItemClientListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/items',
            query: {
                'branchId': branchId,
                'showcaseId': showcaseId,
                'name': name,
                'venderId': venderId,
                'categoryIds': categoryIds,
                'minPrice': minPrice,
                'maxPrice': maxPrice,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns Pagination1OfMealItemClientListedDto OK
     * @throws ApiError
     */
    public static getItemsForMealsClient({
        name,
        venderId,
        branchId,
        categoryIds,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        name?: string,
        venderId?: number,
        branchId?: number,
        categoryIds?: Array<number>,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfMealItemClientListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/items/meals',
            query: {
                'name': name,
                'venderId': venderId,
                'branchId': branchId,
                'categoryIds': categoryIds,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns ItemClientDto OK
     * @throws ApiError
     */
    public static getPublicItemClient({
        id,
        language,
    }: {
        id: number,
        language?: Language,
    }): CancelablePromise<ItemClientDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/items/public/{id}',
            path: {
                'id': id,
            },
            query: {
                'language': language,
            },
        });
    }
    /**
     * @returns Pagination1OfItemClientListedDto OK
     * @throws ApiError
     */
    public static getPublicItemsClient({
        branchId,
        showcaseId,
        categoryIds,
        name,
        venderId,
        language,
        minPrice,
        maxPrice,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        branchId?: number,
        showcaseId?: number,
        categoryIds?: Array<number>,
        name?: string,
        venderId?: number,
        language?: Language,
        minPrice?: number,
        maxPrice?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfItemClientListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/items/public',
            query: {
                'branchId': branchId,
                'showcaseId': showcaseId,
                'categoryIds': categoryIds,
                'name': name,
                'venderId': venderId,
                'language': language,
                'minPrice': minPrice,
                'maxPrice': maxPrice,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
        });
    }
    /**
     * **Required Policy:** `ViewItemDetails`
     * @returns ItemAdminDto OK
     * @throws ApiError
     */
    public static getItemAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ItemAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/items/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItems`
     * @returns any OK
     * @throws ApiError
     */
    public static putItemAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutItemAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/items/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteItems`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteItemAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/items/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewItems`
     * @returns Pagination1OfItemAdminListedDto OK
     * @throws ApiError
     */
    public static getItemsAdmin({
        createdAtFrom,
        createdAtTo,
        branchId,
        categoryId,
        venderId,
        isAvailable,
        disabled,
        onlyDiscounted,
        hasNoImage,
        hasSelection,
        searchWord,
        discountedForUserId,
        itemIds,
        orderSupportTypes,
        approvalStatus,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        createdAtFrom?: string,
        createdAtTo?: string,
        branchId?: number,
        categoryId?: number,
        venderId?: number,
        isAvailable?: boolean,
        disabled?: boolean,
        onlyDiscounted?: boolean,
        hasNoImage?: boolean,
        hasSelection?: boolean,
        searchWord?: string,
        discountedForUserId?: string,
        itemIds?: Array<number>,
        orderSupportTypes?: Array<ItemOrderSupportType>,
        approvalStatus?: ItemApprovalStatus,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfItemAdminListedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/items',
            query: {
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'branchId': branchId,
                'categoryId': categoryId,
                'venderId': venderId,
                'isAvailable': isAvailable,
                'disabled': disabled,
                'onlyDiscounted': onlyDiscounted,
                'hasNoImage': hasNoImage,
                'hasSelection': hasSelection,
                'searchWord': searchWord,
                'discountedForUserId': discountedForUserId,
                'itemIds': itemIds,
                'orderSupportTypes': orderSupportTypes,
                'approvalStatus': approvalStatus,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItems`
     * @returns any OK
     * @throws ApiError
     */
    public static postItemAdmin({
        requestBody,
    }: {
        requestBody?: PostItemAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewItems`
     * @returns Pagination1OfItemDiscountAdminDto OK
     * @throws ApiError
     */
    public static getDiscountedItemsAdmin({
        userId,
        branchId,
        categoryId,
        searchWord,
        branchCompanyId,
        mealTierId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        userId?: string,
        branchId?: number,
        categoryId?: number,
        searchWord?: string,
        branchCompanyId?: number,
        mealTierId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfItemDiscountAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/items/discounted',
            query: {
                'userId': userId,
                'branchId': branchId,
                'categoryId': categoryId,
                'searchWord': searchWord,
                'branchCompanyId': branchCompanyId,
                'mealTierId': mealTierId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `SyncAlgoliaItems`
     * @returns any OK
     * @throws ApiError
     */
    public static syncItemsAdmin({
        branchId,
    }: {
        branchId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/items/sync/{branchId}',
            path: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItems`
     * @returns any OK
     * @throws ApiError
     */
    public static putItemGalleryOrderAdmin({
        id,
        newOrder,
    }: {
        id: string,
        newOrder: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/items/{id}/gallery-order/{newOrder}',
            path: {
                'id': id,
                'newOrder': newOrder,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageItems`
     * @returns any OK
     * @throws ApiError
     */
    public static putItemOrderAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutItemOrderRequestAdmin,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/items/{id}/order',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewItemDetails`
     * @returns GetItemMealTiersAdminResponse OK
     * @throws ApiError
     */
    public static getItemMealTiersAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetItemMealTiersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/items/{id}/meal-tiers',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewItemDetails`
     * @returns GetItemMealTiersAdminResponse OK
     * @throws ApiError
     */
    public static putItemMealTiersAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutItemMealTiersAdminRequest,
    }): CancelablePromise<GetItemMealTiersAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/items/{id}/meal-tiers',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
